export default __webpack_public_path__ + "static/media/avatar.731fb61a.png";